import { GlCheckbox, GlCheckboxProps } from '@adl/component-checkbox'
import { GlLink } from '@adl/component-link'
import { GlTooltip } from '@adl/component-tooltip'
import { useConfig } from '@crystal/config'
import { useTranslations, Translations } from '@crystal/translator'
import { FC, useEffect, useState } from 'react'

import { AccountPortalConfig } from '../config'
import { getProdRedirectUrl } from '../utils'

import styles from './account-portal.module.scss'

export const PersistentLoginCheckbox: FC<GlCheckboxProps> = props => {
  const t = useTranslations<Translations>()
  const { brand, locale, preSelectedPersistentLogin, env } = useConfig<AccountPortalConfig>()
  const [isChecked, setIsChecked] = useState(preSelectedPersistentLogin)

  const prodRedirectUrl = getProdRedirectUrl('/privacy_policy', brand, locale, env)

  useEffect(() => {
    if (!props.onChange) {
      return
    }

    // notify the initial value
    props.onChange({
      target: {
        type: 'checkbox',
        name: props.name,
        checked: isChecked,
      },
    } as React.ChangeEvent<HTMLInputElement>)
  }, [])

  const label = (
    <>
      <p className={styles['right-space']}>{t('persistent.login.label')}</p>
      <GlTooltip label={t('persistent.login.info')} placement="right">
        <p>{t('persistent.login.tooltip')}</p>
        <GlLink href={prodRedirectUrl} className="gl-link">
          {t('privacy.notice')}
        </GlLink>
      </GlTooltip>
    </>
  )

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked)
    props.onChange && props.onChange(event)
  }

  return (
    <GlCheckbox
      {...omit('id', props)}
      data-auto-id="persistent-login-checkbox"
      onChange={onChange}
      label={label}
      isChecked={isChecked}
    />
  )
}

function omit(key: string, obj: unknown) {
  // eslint-disable-next-line
  const { [key]: _omitted, ...rest } = obj as Record<string, unknown>
  return rest
}
